import React, { useEffect, useState } from "react";

const PaymentBlock = ({
  profile,
  onClose,
  onRenewMembership, // 👈 callback para abrir el modal de renovación
}) => {
  const [daysLeft, setDaysLeft] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (!profile?.centralizedExpirationDate) return;

    try {
      const expiration = profile.centralizedExpirationDate.toDate();
      const now = new Date();

      const diffTime = expiration.getTime() - now.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      setDaysLeft(diffDays);
      setIsExpired(expiration < now);
    } catch (error) {
      console.error("Error interpretando fecha de expiración:", error);
    }
  }, [profile]);

  if (!profile) return null;
  if (!profile.centralizedExpirationDate) return null;

  if (daysLeft > 3 && !isExpired) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 p-4">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-lg p-8 relative text-center">
        {/* HEADER */}
        <h2 className="text-2xl font-bold text-red-600 mb-4">
          {isExpired ? "⚠️ Membresía Vencida" : "⚠️ Tu membresía está por vencer"}
        </h2>

        {/* MENSAJE */}
        <p className="text-gray-700 dark:text-gray-300 mb-6">
          {isExpired ? (
            <>
              El perfil <strong>{profile.name}</strong> ha{" "}
              <span className="text-red-500 font-semibold">expirado</span>.  
              Debes renovar tu membresía para poder seguir usando nuestros servicios.
            </>
          ) : (
            <>
              El perfil <strong>{profile.name}</strong> vencerá en{" "}
              <span className="font-semibold text-yellow-600">{daysLeft} días</span>.  
              Te recomendamos renovar antes de la fecha límite para no perder acceso.
            </>
          )}
        </p>

        {/* BOTONES */}
        <div className="flex justify-center space-x-4">
          {/* BOTÓN RENOVAR */}
          <button
            onClick={onRenewMembership} // 👈 se llama al callback que abre tu modal de renovar
            className="px-6 py-2 rounded-md bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
          >
            Renovar Membresía
          </button>

         {/* BOTÓN CONTINUAR (siempre disponible para poder cambiar de perfil) */}
            <button
            onClick={onClose}
            className="px-6 py-2 rounded-md bg-gray-300 text-gray-800 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-400 dark:hover:bg-gray-600 transition"
            >
            Continuar sin renovar
            </button>

        </div>
      </div>
    </div>
  );
};

export default PaymentBlock;
